import React from 'react';
import { Modal } from 'antd';
import { identity } from 'lodash';

export function DisplayImage({
  show = false,
  imageSrc = '',
  onClose = identity,
}) {
  return (
    <Modal open={show} footer={null} centered onCancel={onClose}>
      <img src={imageSrc} width="100%" alt="display" />
    </Modal>
  );
}
